import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectField from '../../../components/forms/SelectField';
import { CONTRACT_TYPES, CONTRACT_TYPE_OPTIONS } from '../../../constants/settings';

import { filtersSelector } from '../../../selectors/admin/tables';
import {
    canAccessClearanceInAdminSelector,
    canAccessPerformanceInAdminSelector
} from '../../../selectors/authentication';

class ArchiveSearchForm extends Component {
    render() {
        const { filters = {} } = this.props;
        return (
            <div className="ckp-admin-search-form ckp-grid-row">
                <SelectField
                    onChange={this.props.updateFilter}
                    className="u-margin-right-3"
                    label="Type"
                    disabled={!this.props.accessToPerformance || !this.props.accessToClearance}
                    name="type"
                    items={CONTRACT_TYPE_OPTIONS}
                    value={
                        filters.type ||
                        (this.props.accessToClearance ? CONTRACT_TYPES.CLEARANCE : CONTRACT_TYPES.PERFORMANCE)
                    }
                />
                <p className="ckp-admin-search-form-total">
                    <label className="u-italic u-margin-right-1 u-inline-block">Total:</label>
                    <span className="u-bold u-color-blue u-inline">{this.props.total}</span>
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    filters: filtersSelector(state),
    accessToPerformance: canAccessPerformanceInAdminSelector(state),
    accessToClearance: canAccessClearanceInAdminSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveSearchForm);
